<template>
  <section class="calendar">
    <iframe
      src="https://calendar.google.com/calendar/embed?src=enjoywork5566%40gmail.com&ctz=Asia%2FTaipei"
      frameborder="0"
      scrolling="no"
      class="calendar__iframe"
      title="廟宇宗教文化行事曆"
    ></iframe>
  </section>
</template>

<script>
export default {
  name: 'TheGoogleCalendar',
  metaInfo() {
    return {
      title: '行事曆',
    };
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
.calendar {
  text-align: center;

  &__iframe {
    border: 0;
    min-width: 300px;
    width: 80%;
    height: 600px;
  }
}
</style>
